import React from "react";
import { gloves, qhseBg } from "../../../../assets/images";
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const GlovesHelmets = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <SubOtherHero title="PPE Equipment" />
      </div>

      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row">
          {/* Left Text */}
          <div className="md:w-1/2">
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {t("PPE Equipment")}
            </p>

            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "We offer a full range of high-quality Personal Protective Equipment to ensure safety in industrial environments. Our products include durable gloves, certified safety helmets, comfortable and protective workwear, safety gear for all conditions, and impact-resistant protective glasses. Designed to meet international safety standards, our PPE solutions help safeguard your workforce in even the most demanding work environments."
              )}
            </p>
          </div>

          {/* Right Image */}
          <div className="md:w-1/2 grid grid-cols-1 gap-4 mt-8 md:mt-0">
            <img
              src={gloves}
              alt="Drill Bit 1"
              className="w-full rounded-lg shadow-md"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default GlovesHelmets;
